/*  /frontend/src/context/UserContext.js
    Greatly Social – global user/session cache
    FULL FILE — NOTHING OMITTED
    -------------------------------------------------------------- */

import { createContext, useState, useEffect } from 'react'
import axios from 'axios'
import { useLoading } from './LoadingContext'

export const UserContext = createContext({
  user:     null,     // null = loading, {} = guest, {…} = logged-in
  setUser:  () => {},
  loading:  true,
})

/* ------------------------------------------------------------------
   Decide the API root once:

   – In production set REACT_APP_BACKEND_URL in .env*
     e.g.   REACT_APP_BACKEND_URL=https://greatlysocial.com
     ( NO trailing slash )

   – Otherwise default to '/api' which Apache reverse-proxies
------------------------------------------------------------------- */
const ENV_ROOT = (process.env.REACT_APP_BACKEND_URL || '').trim()
const API_BASE = ENV_ROOT ? `${ENV_ROOT}/api` : '/api'   // <─ ★ HERE

export function UserProvider ({ children }) {
  const [user,    setUser]    = useState(null)
  const [loading, setLoading] = useState(true)

  const { show, hide } = useLoading()

  useEffect(() => {
    (async () => {
      try {
        show(null)

        /* ----------------------------------------------------------
           GET  /api/auth/me      (or https://site.com/api/auth/me)
           -------------------------------------------------------- */
        const { data } = await axios.get(`${API_BASE}/auth/me`, {
          withCredentials: true,
        })

        // Logged-in user → object   |   Guest → {}
        setUser(data.user ?? {})
      } catch (err) {
        console.error('UserContext: /auth/me failed', err)
        setUser({})            // treat as guest
      } finally {
        setLoading(false)
        hide()
      }
    })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      {children}
    </UserContext.Provider>
  )
}
